import * as React from 'react'
import * as PropTypes from 'prop-types'
import { ConnectedRouter } from 'connected-react-router'
import { StaticRouter } from 'react-router'

import IsomorphicContext from '../../../contexts/IsomorphicContext'

function IsomorphicRouter(props) {
  // TODO: define template, behaviors etc.
  const { context, history, location, children, ...theProps } = props

  return (
    <IsomorphicContext.Consumer>
      {server => {
        return (
          <>
            {server.server && (
              <StaticRouter {...theProps} location={location} context={context}>
                {children}
              </StaticRouter>
            )}
            {!server.server && (
              <ConnectedRouter {...theProps} history={history}>
                {children}
              </ConnectedRouter>
            )}
          </>
        )
      }}
    </IsomorphicContext.Consumer>
  )
}

IsomorphicRouter.defaultProps = {
  context: null,
  history: null,
}

IsomorphicRouter.propTypes = {
  context: PropTypes.shape(),
  history: PropTypes.shape(),
}

export default IsomorphicRouter
